const CoordinationMechanism = () =>
  import('@/views/main/report/coordinationMechanism/CoordinationMechanism.vue')
export default {
  path: '/main/report/CoordinationMechanism',
  name: 'CoordinationMechanism',
  component: CoordinationMechanism,
  children: []
}
